import { config, IS_CLIENT, IS_PROD } from "../config";
import { createHmac } from "crypto";

declare global {
  /* eslint-disable-next-line @typescript-eslint/consistent-type-definitions */
  interface Window {
    churnkey?: {
      created: boolean;
      init: (
        action: string,
        config: {
          customerId: string;
          authHash: string;
          appId: string;
          mode: "live" | "test";
          provider: string;
          record: boolean;
          handleSupportRequest?: () => void;
        }
      ) => void;
      hide: () => void;
      check: (
        action: string,
        config: {
          customerId: string;
          authHash: string;
          appId: string;
          provider: string;
          mode: "live" | "test";
          softWall: boolean;
          onPauseWallClose?: () => void;
        }
      ) => void;
    };
  }
}
export const scriptUrl = `https://assets.churnkey.co/js/app.js?appId=${config.CHURNKEY_APP_ID}`;

export const initChurnkey = () => {
  if (IS_CLIENT) {
    if (!config.CHURNKEY_APP_ID) {
      return;
    }
    if (!window.churnkey?.created) {
      window.churnkey = {
        created: true,
        /* eslint-disable-next-line @typescript-eslint/no-empty-function */
        init: () => {}, // Placeholder until script loads
        /* eslint-disable-next-line @typescript-eslint/no-empty-function */
        hide: () => {}, // Placeholder until script loads
        /* eslint-disable-next-line @typescript-eslint/no-empty-function */
        check: () => {}, // Placeholder until script loads
      };
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      document.head.appendChild(script);

      // Cleanup function to remove script on unmount
      return () => {
        if (IS_CLIENT) {
          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }
          // Reset churnkey state
          window.churnkey = undefined;
        }
      };
    }
  }
};

export const generateUserHash = (customerId: string | undefined) => {
  if (!config.CHURNKEY_API_KEY || !customerId) {
    return null;
  }
  return createHmac("sha256", config.CHURNKEY_API_KEY).update(customerId).digest("hex");
};

export const checkSubscriptionPause = (stripeCustomerId: string | undefined) => {
  if (!window.churnkey || !config.CHURNKEY_APP_ID || !stripeCustomerId) {
    return;
  }

  const hash = generateUserHash(stripeCustomerId);
  if (!hash) {
    return;
  }

  window.churnkey.check("pause", {
    customerId: stripeCustomerId,
    authHash: hash,
    appId: config.CHURNKEY_APP_ID!,
    provider: "stripe",
    mode: IS_PROD ? "live" : "test",
    softWall: false,
  });
};
